<template>
  <div class="wrap-content" :class="{ 'small-content' : type === 'small'}">
    <slot />
  </div>
</template>
<script>
export default {
  name: "Wrap",
  props: {
    type: String,
  },
};
</script>
<style lang="scss">
.wrap-content {
  padding-top: 90px;
}
.small-content {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}
</style>